/**
 * @author vishwadeep.kapoor
 * Profile actions
 *
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import { constants, utils, eventTracking } from '../../devUtils';
import { rootApiResponse, clearDefaultError, setProfileLogout, loginError, GET_REQ_HANDLER, getUpdatedUserProfile } from '../HeaderContainer/actions';
import { DEFAULT_ACTION, PASSWORD_UPDATE_SUCCESS, PROFILE_CONSTANT } from './constants';
import { getLogoutRedirectPath } from '../../devUtils/commonUtils';

const successActionData = (payload) => ({ type: PASSWORD_UPDATE_SUCCESS, payload });

const savePasswordChange = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_USER_PASSWORD, payload, authPrerequist);
    if (response.message) {
      throw (response.message);
    } else {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      dispatch(successActionData(true));
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ALERT_PASSWORD_UPDATED)));
      eventTracking.triggerEvent('My Account', 'Change Password Confirm', 'Success');
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    eventTracking.triggerEvent('My Account', 'Change Password Confirm', 'Failure');
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

const userLogout = (history, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const { landing_page_url } = utils.immutableToJS(utils.immutableUserDetails(getState));
    const { client_series } = otherParams;
    const response = await reqHandler.deleteHandler(api, endpoint.DELETE_BROWSER_LOGOUT, null, authPrerequist);
    if (response && response.message) {
      await reqHandler.postHandler(api, endpoint.POST_SET_TOKEN, {});
      dispatch(rootApiResponse(utils.successResponse('LOGOUT', constants.ALERT_LOGOUT_SUCCESS)));
      eventTracking.triggerEvent('My Account', 'Logout', 'Success');
      dispatch(setProfileLogout());
      dispatch(loginError());
      const redirectPath = getLogoutRedirectPath(client_series, landing_page_url);
      utils.forceRedirect(history, redirectPath);
    } else {
      throw (response.message);
    }
  } catch (err) {
    dispatch(rootApiResponse(utils.errorResponse('LOGOUT', err)));
    eventTracking.triggerEvent('My Account', 'Logout', 'Failure');
  }
};

const WalletRegister = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = payload.otp_ref_number ? endpoint.POST_WALLET_VERIFY_OTP : endpoint.POST_WALLET_REGISTER;
    const response = await reqHandler.postHandler(api, URL, payload, authPrerequist);
    if (response && response.status) {
      // if (!response.otp_ref_number) { // for already existing user
      //   dispatch(getUpdatedUserProfile());
      // }
      dispatch({ type: PROFILE_CONSTANT.WALLET_REGISTER, payload: { ...response, ts: Date.now() } });
      return dispatch(rootApiResponse(utils.successResponse('WalletRegister', response.message)));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse('WalletRegister', err)));
  }
};

const AadharRegister = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = payload.transaction_id ? endpoint.POST_AADHAAR_OTP_VERIFY : endpoint.POST_AADHAAR_KYC;
    const response = await reqHandler.postHandler(api, URL, payload, authPrerequist);
    if (response && response.status) {
      if (!response.transaction_id) {
        dispatch(getUpdatedUserProfile());
      }
      dispatch({ type: PROFILE_CONSTANT.AADHAR_REGISTER, payload: { ...response, ts: Date.now() } });
      await new Promise((resolve) => setTimeout(resolve, 4000));
      return dispatch(rootApiResponse(utils.successResponse('AadharRegister', response.message)));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse('AadharRegister', err)));
  }
};

const PhysicalCardActivate = (payload, { apiMethod }) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = apiMethod === 'GET' ? endpoint.GET_PHYSICAL_CARD_ACTIVATE : endpoint.POST_PHYSICAL_CARD_ACTIVATE;
    const response = await GET_REQ_HANDLER(apiMethod)(api, URL, payload, authPrerequist);
    if (response && response.status) {
      dispatch(getUpdatedUserProfile());
      dispatch({ type: PROFILE_CONSTANT.CARD_ACTIVATE, payload: { ...response, ts: Date.now() } });
      return dispatch(rootApiResponse(utils.successResponse('PhysicalCardActivate', response.message)));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse('PhysicalCardActivate', err)));
  }
};

export {
  userLogout, savePasswordChange, WalletRegister, AadharRegister, PhysicalCardActivate,
};



// WEBPACK FOOTER //
// client/containers/Profile/actions.js